"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const circle_svg_component_1 = require("./circle-svg-component");
const image_svg_component_1 = require("./image-svg-component");
const map_pin_card_svg_component_1 = require("./map-pin-card-svg-component");
class MapPinSvgComponent {
    constructor(mapPin, snapCtx, position, dimensions) {
        this.mapPin = mapPin;
        this.snapCtx = snapCtx;
        this.position = position;
        this.dimensions = dimensions;
    }
    draw() {
        return new Promise((resolve, reject) => {
            const pinImage = new image_svg_component_1.ImageSvgComponent(this.mapPin.imageSource, this.snapCtx, this.position, this.dimensions);
            const circleForPin = this.getCircleComponentForPin();
            const nameCard = this.getMapPinCardComponent();
            pinImage.draw().then(() => {
                circleForPin.draw();
                nameCard.draw();
                this.addBehaviourToShowMapPinCardOnCircleHover(circleForPin, nameCard);
                this.addBehaviourToExecuteCallbackOnCircleClick(circleForPin);
            });
            resolve();
        });
    }
    getCircleComponentForPin() {
        const circleDimensions = this.getCircleDimensions(this.dimensions);
        const circlePosition = this.getCirclePosition(this.dimensions, this.position);
        return new circle_svg_component_1.CircleSvgComponent(this.snapCtx, circlePosition, circleDimensions);
    }
    getCircleDimensions(pinDimensions) {
        const circleRadius = this.getCircleRadius(pinDimensions);
        return { radius: circleRadius };
    }
    getCircleRadius(pinDimensions) {
        return pinDimensions.width * 0.10;
    }
    getCirclePosition(pinDimensions, pinPosition) {
        const circleRadius = this.getCircleRadius(pinDimensions);
        const circleX = pinPosition.x + pinDimensions.width / 2;
        const circleY = this.position.y + (this.dimensions.height * 1.10) + circleRadius;
        return { x: circleX, y: circleY };
    }
    getMapPinCardComponent() {
        const mapPinDetails = { title: this.mapPin.name, description: this.mapPin.description };
        const mapPinCardDimensions = this.getMapPinCardDimensions(this.dimensions);
        const mapPinCirclePosition = this.getCirclePosition(this.dimensions, this.position);
        return new map_pin_card_svg_component_1.MapPinCardSvgComponent(mapPinDetails, this.snapCtx, mapPinCirclePosition, mapPinCardDimensions);
    }
    getMapPinCardDimensions(pinDimensions) {
        const mapPinCardWidth = pinDimensions.width * 3;
        const mapPinCardHeight = pinDimensions.height * 1.5;
        return { width: mapPinCardWidth, height: mapPinCardHeight };
    }
    addBehaviourToShowMapPinCardOnCircleHover(pinCircle, pinCard) {
        pinCircle.element.hover((hoverInHandler) => {
            pinCard.show();
        }, (hoverOutHandler) => {
            pinCard.hide();
        });
    }
    addBehaviourToExecuteCallbackOnCircleClick(pinCircle) {
        pinCircle.element.click(() => {
            this.mapPin.callbackFunction(this.mapPin);
        });
    }
}
exports.MapPinSvgComponent = MapPinSvgComponent;
